import { useState, useEffect } from "react";
import TopNav from "./components/TopNav";
import SearchFilter from "./components/SearchFilter";
import LayerControl from "./components/LayerControl";
import MapPage from "./components/MapPage";
// import BuildingInfoList from "./components/mapview/BuildingInfoList";
import GridSearch from "./components/GridSearch";
import AIAgent from "./components/AIAgent";
import { CITY_COORDS } from "../../mocks/cityCoords";

const DEFAULT_LAYERS: Record<string, boolean> = {
  residential: false,
  commercial: false,
  industrial: false,
  street_shop: false,
  admin_5: false,
  road_network: false,
  building: false,
  building_white: false,
  poi: false,
  poi_food: false,
  poi_hotel: false,
  poi_shop: false,
  poi_medical: false,
  poi_traffic: false,
  poi_company: false,
  aoi: false,
  aoi_school: false,
  aoi_hospital: false,
  aoi_gov: false,
  aoi_park: false,
  aoi_scenic: false,
  aoi_cbd: false,
  address: false,
  addr_village: false,
  addr_market: false,
  addr_enterprise: false,
  rural_cluster: false,
  remote_sensing: false,
  rs_05m: false,
  rs_2m: false,
  rs_dsm: false,
  rs_dem10m: false,
  rs_tilt: false,
  // 新增的动态数据图层
  xiaoqu_biaozhu: false,
  changjing_biaozhu: false,
  xiangzhen_dian: false,
  poi_point: false,
  dem: false,
  jianzhuwu_baimo: false,
};

export default function Home() {
  const [city, setCity] = useState("南京");
  const [activeLayers, setActiveLayers] = useState<Record<string, boolean>>(DEFAULT_LAYERS);
  const [poiListData, setPoiListData] = useState<any[]>([]);
  const [showPoiList, setShowPoiList] = useState(false);
  const [checkTypeData, handleCheckType] = useState<any>(null);
  const [gridData, setGridData] = useState<{ district?: any; street?: any } | null>(null);
  const [mapSelectedStreet, setMapSelectedStreet] = useState<{ gid: string; name: string } | null>(null);
  const [drawingMode, setDrawingMode] = useState(false);
  const [layerControlCollapsed, setLayerControlCollapsed] = useState(true);
  const [aiSearchQuery, setAiSearchQuery] = useState("");

  // 监听 FastGPT postMessage
  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      const data = event.data;
      console.log(data, 'ai data');
      
      if (data?.type === "shareChatFinish" && data?.data?.answer) {
        // 打印完整返回数据调试
        console.log('[FastGPT 完整返回]', JSON.stringify(data.data, null, 2));
        // 从 answer 中提取场景名称，格式如: "会自动跳转至 “公教一村”"
        const match = data.data.answer.match(/会自动跳转至 ["“]([^"”]+)/);
        const sceneName = match ? match[1].trim() : "";
        if (sceneName) {
          console.log('[AI搜索] 提取场景名称:', sceneName);
          setAiSearchQuery(sceneName);
        }
      }
    };
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  const handleCityChange = (newCity: string) => {
    setCity(newCity);
  };

  const handleLocationSelect = (longitude: number, latitude: number, name: string, data?: Record<string, any>) => {
    if ((window as any).flyToLocation) {
      (window as any).flyToLocation(longitude, latitude, name, data);
    }
  };


  const SimpleHeader = () => (
    <div className="absolute top-0 left-0 w-full z-50 bg-white/90 backdrop-blur-sm p-4">
      <TopNav />
    </div>
  );

  return (
    <div className="relative w-screen h-screen overflow-hidden" style={{ fontFamily: "'Noto Sans SC', sans-serif" }}>
      {/* 地图组件 */}
      <MapPage
        headerComponent={<SimpleHeader />}
        activeLayers={activeLayers}
        city={city}
        cityCoordinates={CITY_COORDS}
        onLocationSelect={handleLocationSelect}
        // onPoiListDataChange={setPoiListData}
        // onPoiListVisibleChange={setShowPoiList}
        onDataFromGridSearch={gridData}
        drawingMode={drawingMode}
        onDrawingChange={setDrawingMode}
        layerControlCollapsed={layerControlCollapsed}
        onMapStreetSelect={(street) => setMapSelectedStreet(street)}
      />

      {/* 搜索组件（含快捷查询 + 地址搜索 + 区划搜索 + AI 智能搜索） */}
      <SearchFilter
        city={city}
        onCityChange={handleCityChange}
        onLocationSelect={handleLocationSelect}
        onCheckTypeSelect={handleCheckType}
        onGridSelect={(data: any) => setGridData(data)}
        mapSelectedStreet={mapSelectedStreet}
        drawingMode={drawingMode}
        onDrawingChange={setDrawingMode}
        aiKeyword={aiSearchQuery}
      />

      {/* 图层控制组件 */}
      <LayerControl checked={activeLayers} onCheckedChange={setActiveLayers} collapsed={layerControlCollapsed} onCollapsedChange={setLayerControlCollapsed} />

      {/* 网格搜索组件（已迁移到定位面板「按区划」Tab） */}
      {/* <GridSearch
        city={city}
        drawingMode={drawingMode}
        onDrawingChange={setDrawingMode}
        onDataFromGridSearch={setGridData}
        aiSearchQuery={aiSearchQuery}
      /> */}

      <AIAgent onAiSearchQuery={setAiSearchQuery} />
    </div>
  );
}